import { IsNotEmpty, IsUUID } from 'class-validator';

export class ApprovalParamsDto {
  @IsUUID()
  @IsNotEmpty()
  employeeId: string;

  @IsUUID()
  @IsNotEmpty()
  companyId: string;

  @IsUUID()
  @IsNotEmpty()
  unitId: string;
}
